import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pop-up-message-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { class: "description-wrapper" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "wks-open-input-wrapper" }

import { ref, onBeforeMount, toRefs } from 'vue'
import { IonContent, IonPage, toastController } from "@ionic/vue";
import { getComputedPageLayout, getIcon } from '@/helpers/api';
import { SolutionData, useWorksheetHandler } from '@/globals/helpers/worksheetHandler';
import { worksheetService } from '@/modules/a.worksheets/services/worksheet.service';
import { Wks_Modals, useModalManager } from '@/modules/a.worksheets/services/modalManager';
import { useOpenInput, TInputButton } from '@/modules/a.worksheets/helpers/wksOpenInput';
import WksOpenInput from "@/modules/a.worksheets/views/components/footer/WksOpenInput.vue";
import PopUpMask from '@/modules/a.worksheets/views/components/feedback/PopUpMask.vue'
import { computedAsync } from '@vueuse/core';
import WksOpenInputOneFile from '@/modules/a.worksheets/views/components/footer/WksOpenInputOneFile.vue'
import { spinnerManager } from '@/globals/pages/spinnerControl';
import { useDeviceStatus } from '@/stores/deviceStatus';

interface _1616A {
    labels: {
        title: string,
        lines: Array<string>,
    },
    helps: {
        msg: string,
    },
    errors: {
        maxSizeMBytes: string,
        maxDuration: string
    },
    commands: {
        audio: boolean,
        document: boolean,
        photo: boolean,
        video: boolean,
        pdf: boolean,
        text: boolean,
        maxNumFiles: number,
        maxSizeMBytes: number,
        maxDuration: number
    }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewSolutionModal',
  setup(__props) {

const { isWeb } = toRefs(useDeviceStatus());

const icon = ref<string>()
const layout = getComputedPageLayout<_1616A>('1616A')
onBeforeMount(async () => {
    icon.value = await getIcon('1616A', 'icon')
})

const { textBtn, createBtn } = useOpenInput();
async function catchMedia(data: string | File[], type: SolutionData){
    const problemUUID = wh.$.activity.problem.value?.uuid
    if(problemUUID){
        if(Array.isArray(data) && layout.value){    
            if(isGreaterThen(data[0], layout.value.commands.maxSizeMBytes * 1024 * 1024)){
                const toast = await toastController.create({
                    message: layout.value.errors.maxSizeMBytes + layout.value.commands.maxSizeMBytes,
                    duration: 1500,
                    position: "top"
                })
                toast.present();
                return;
                /// This condition has not been tested properly since only photo and pdf is allowed yet
            }else if(data[0].type.includes('audio') && await greaterDuration(data[0], layout.value.commands.maxDuration)){
                const toast = await toastController.create({
                    message: layout.value.errors.maxDuration + layout.value.commands.maxDuration,
                    duration: 1500,
                    position: "top"
                })
                toast.present()
                return;
            }
        }

        spinnerManager.registerTask("sending feedback")
        await submitNewSolution(data)
        spinnerManager.unregisterTask("sending feedback")
    }
}

function isGreaterThen(file: File, size: number): boolean {
    console.log(`file.size: ${file.size} > size: ${size}`)
    if(file.size > size){
        return true
    }else{
        return false
    }
}
async function greaterDuration(file: File, maxDuration: number): Promise<boolean> {
    const duration = await getAudioDuration(URL.createObjectURL(file))
    if(duration > maxDuration){
        return true
    }else{
        return false
    }
}

async function getAudioDuration(url: string): Promise<number> {
    return await new Promise<number>((resolve, reject) => {
      const audio = new Audio(url);
      // Set the preload attribute to 'metadata'
      audio.preload = "metadata";

      // Attach the loadedmetadata event listener
      audio.addEventListener("loadedmetadata", () => {
        console.log("audio duration inside listener: ", audio.duration);
        resolve(audio.duration);
      });
      // Attach an error event listener
      audio.addEventListener("error", () => {
        reject(new Error("Failed to load audio metadata"));
      });
    });
  }

const getMediaButtons = computedAsync<TInputButton[]>(async () => {
    const buttons: TInputButton[] = [];

    if(layout.value?.commands.photo){
        const btn = await createBtn('photo', true);
        buttons.push(btn!);
    }
    if(layout.value?.commands.video){
        const btn = await createBtn('video', true);
        buttons.push(btn!);
    }
    if(layout.value?.commands.audio){
        const btn = await createBtn('audio', true);
        buttons.push(btn!);
    }
    if(layout.value?.commands.document){
        const btn = await createBtn('document', true);
        buttons.push(btn!);
    }
    if(layout.value?.commands.pdf){
        const btn = await createBtn('pdf', true);
        buttons.push(btn!);
    }
    if(buttons.length > 2){
        const btn = await createBtn('expand', true);
        buttons.push(btn!);
    }
    return buttons;
})


const wh = useWorksheetHandler()
const modalManager = useModalManager()
async function submitNewSolution(data: string | File[]){
    const problemUUID = wh.$.activity.problem.value?.uuid
    if(problemUUID){
        const response = await worksheetService.postNewSolution(wh.wksUUID.value, problemUUID, data)
        if(response.status === 200){
            modalManager.open(Wks_Modals.NEW_SOLUTION_THANKS)
        }
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          (_unref(layout))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(PopUpMask, null, {
                  icon: _withCtx(() => [
                    _createElementVNode("img", { src: icon.value }, null, 8, _hoisted_2)
                  ]),
                  title: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(layout).labels.title), 1)
                  ]),
                  description: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout).labels.lines, (line, key) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: key,
                          innerHTML: line
                        }, null, 8, _hoisted_5))
                      }), 128))
                    ])
                  ]),
                  button: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(WksOpenInputOneFile, {
                        "media-button": _unref(getMediaButtons),
                        placeholder: _unref(layout).helps.msg,
                        onSetMedia: catchMedia
                      }, null, 8, ["media-button", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})